import getLogger from '@ignitesales/logger-es';
import {ignite, buildPageUrl} from '@ignitesales/neuro-application';
import queryString from 'query-string';

const logger = getLogger({ module: 'wsfs-consumer-online-actions' });

const WsfsConsumerOnlineActions = {
  DEEP_LINK_CHECK_FINISHED: 'DEEP_LINK_CHECK_FINISHED'
};

const checkAndGoToDeepLink = () => {
  const validPaths = ['checking', 'savings', 'borrow', 'all'];

  return async (dispatch, getState) => {
    try {
      const urlQuery = window.location.search;
      logger.debug('Checking for deep link', urlQuery);
      const parsed = queryString.parse(urlQuery);
      const pathParam = parsed.path || '';

      if (pathParam && validPaths.includes(pathParam)) {
        const reasonForVisitAnswers = await ignite.answerService.getAnswer('reasonForVisit');
        const newAnswerValue = reasonForVisitAnswers.value && reasonForVisitAnswers.value.length > 0
          ? [...reasonForVisitAnswers.value, pathParam]
          : [pathParam];

        logger.debug('Saving answers via deep link', newAnswerValue);
        await ignite.answerService.saveAnswer({
          appkey: 'reasonForVisit',
          value: newAnswerValue,
          timestamp: new Date()
        });

        const state = getState();
        const { user: { uuid } } = state;
        const isAllPath = pathParam === 'all' ? true : false;
        const redirectUrl = buildPageUrl({
          type: 'survey',
          uuid,
          path: { key: 'entry' },
          page: { key: isAllPath ? 'reasonForVisit' : 'isCustomer' }
        });
        logger.debug('redirecting via deep link', redirectUrl)
        window.location.href = redirectUrl;
      } else {
        dispatch({ type: WsfsConsumerOnlineActions.DEEP_LINK_CHECK_FINISHED });
      }
    } catch (ex) {
      dispatch({ type: WsfsConsumerOnlineActions.DEEP_LINK_CHECK_FINISHED })
    }
  }
}

export {
  WsfsConsumerOnlineActions,
  checkAndGoToDeepLink
}
